export default __webpack_public_path__ + "static/media/ResultWarning.d3f41319.png";